import { render, staticRenderFns } from "./ChangePriceForm.vue?vue&type=template&id=d3e573b8&"
import script from "./ChangePriceForm.vue?vue&type=script&lang=js&"
export * from "./ChangePriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports